export default __webpack_public_path__ + "static/media/bg12.fb9314e0.jpg";